import { yupResolver } from '@hookform/resolvers/yup';
import React, { memo, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useForm } from 'react-hook-form';

import Loader from "react-js-loader";
import { ToastContainer, toast } from 'react-toastify';
import * as Yup from 'yup';
import { getEndpointUrl } from "../../Utils/Common";

const CreateBrand = ({ onCallback, show, close }) => {

    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken, setAccessToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    useEffect(() => {

    }, [isLoading]);

    const validationSchema = Yup.object().shape({
        companyName: Yup.string().required('Field harus diisi'),
        originCountry: Yup.string().required('Field harus diisi'),
    });

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = data => {
        setLoading(true);

        let formData = new FormData();

        formData.append('companyName', data.companyName);
        formData.append('originCountry', data.originCountry);
        formData.append('user_id', userLogin.id);

        fetch(getEndpointUrl() + '/v2/car_brand', {
            method: "POST",
            body: formData,
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            setLoading(false);

            if (json.status === 'ok') {

                toast.success("Yay, Data merek berhasil diinput.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                });

                close();

                onCallback(json.results.data);

            } else {
                toast.error(json.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });
            }
        }).catch(error => {
            setLoading(false);
        });
    };
    return (
        <>
            <ToastContainer position="top-end" className="p-3"></ToastContainer>
            <Modal show={show} onHide={close} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{isLoading ? "Menyimpan data..." : "Input data merek"}</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    {isLoading ?
                        <Modal.Body>
                            <div className="d-flex justify-content-center mt-5 mb-5">
                                <Loader type="bubble-scale" bgColor={"#42A5F5"} size={100} />
                            </div>
                        </Modal.Body>
                        :
                        <>
                            <Modal.Body>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Nama Merek</Form.Label>
                                    <Form.Control type="text" {...register("companyName")} isInvalid={errors.companyName ? true : false} autoComplete="off" />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Negara Asal</Form.Label>
                                    <Form.Control type="text" {...register("originCountry")} isInvalid={errors.originCountry ? true : false} autoComplete="off" />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={close}> Batal </Button>
                                <Button variant="success" type="submit">Input data merek</Button>
                            </Modal.Footer>
                        </>
                    }
                </Form>
            </Modal>
        </>
    );
}

export default memo(CreateBrand);
